import { atom } from "recoil";

export const onlinePaymentTransactionAtom = atom({
  key: "onlinePaymentTransactionAtom",
  default: [],
});